/**
 * @architecture-header 1
 * @layer module
 * @domain classrooms
 * @responsibility Hold which materials a teacher has ticked, so the page header can send them all.
 * @state-owner module-scoped Zustand
 * @allowed-imports Zustand; shared transient reset registry
 * @forbidden server entities; roles; permissions; tokens; localStorage; API client
 * @public-api classrooms module
 * @side-effects in-memory UI updates only
 * @tests module-contracts.test.ts
 */

import { create } from 'zustand';
import { registerWorkspaceTransientReset } from '../../../shared/lib/transient-reset';

interface MaterialSelectionState {
  picked: readonly string[];
  toggle(activityId: string): void;
  clear(): void;
}

export const useMaterialSelection = create<MaterialSelectionState>((set) => ({
  picked: [],
  toggle: (activityId) =>
    set((state) => ({
      picked: state.picked.includes(activityId)
        ? state.picked.filter((id) => id !== activityId)
        : [...state.picked, activityId],
    })),
  clear: () => set({ picked: [] }),
}));

registerWorkspaceTransientReset('material-selection', () =>
  useMaterialSelection.getState().clear(),
);
